/**
 * Public feed endpoints.
 *
 * The Stories feed is served live by the `stories-rss` edge function so a story
 * approved in the admin dashboard appears in readers and crawlers immediately,
 * instead of waiting for the next site build.
 */

const FUNCTIONS_BASE =
  `https://${import.meta.env.VITE_SUPABASE_PROJECT_ID ?? "vqxznxajxsoskkojnhqn"}.supabase.co/functions/v1`;

/** RSS 2.0 feed of published Stories of Change. */
export const STORIES_FEED_URL = `${FUNCTIONS_BASE}/stories-rss`;

export const STORIES_FEED_TITLE = "Stories of Change — DrSullySpeaks";
